<div class="flex full-height">
  <div class="flex">
    <bringoz-button *ngIf="!isPdf"
                    type="tertiary"
                    size="fit"
                    (onClick)="openPopup($event)">
      <bringoz-icon [iconName]="isVideo ? 'play' : 'pod'" fill="#424242" size="sm"></bringoz-icon>
    </bringoz-button>

    <div *ngIf="!isPdf" [ngbTooltip]="locationTooltip" openDelay="300" triggers="hover" container="body"></div>

    <ng-template #locationTooltip>
      <app-location-to-place *ngIf="metadata?.location"
                         class="flex layout-row layout-align-start-start margin-bottom-5"
                         [location]="metadata.location">
      </app-location-to-place>
      <span class="br-body-2" *ngIf="!metadata?.location" translate>No Address</span>
      <span class="br-body-2" *ngIf="metadata?.timestamp"
            translate>{{metadata | bringozFullDate: 'timestamp'}}</span>
      <span class="br-body-2" *ngIf="metadata?.timestamp"
            translate>{{metadata | bringozTime: 'timestamp'}}</span>
    </ng-template>

    <bringoz-button *ngIf="isPdf"
                    type="tertiary"
                    size="fit"
                    (onClick)="download($event)">
      <bringoz-icon iconName="pdf"></bringoz-icon>
    </bringoz-button>

    <div *ngIf="isPdf" [ngbTooltip]="pdfTooltip" openDelay="300" triggers="hover" container="body"></div>

    <ng-template #pdfTooltip>
      <span translate>{{text || 'Download PDF'}}</span>
    </ng-template>
  </div>

  <bringoz-button *ngIf="canEdit"
                  aria-label="Edit"
                  size="fit"
                  (onClick)="onEdit.emit()">
    <bringoz-icon iconName="edit-outline" size="sm"></bringoz-icon>
  </bringoz-button>
</div>
